import React from 'react'
import Img from 'gatsby-image'
import Link from 'gatsby-link'
import HomeIcon from 'react-icons/lib/md/home'

const AcercaDe = ({ data }) => (
  <div className="acerca-layout">    
    <Img
      sizes={data.imageSharp.sizes}
      style={{ zIndex: '-1', position:'absolute'}}      
      className='main-bg'
    />
    <div className="container">
      <h1>Fiorella Pattoni</h1>
      <p>Mis piezas se caracterizan por tener simetría y son de formas orgánicas. Me gusta tener de referencia; lenguajes textiles como tejidos y encajes, elementos y gestos de la naturaleza. Diseñar patrones que logren hacer de una pieza de joyería, arte utilitario.</p>
      <p>La relación que poseemos hacia los ornamentos que utilizamos, nos transforman, nos empoderan y terminan de configurar nuestra imagen. Somos una idea diseñada por nosotros mismos, somos un discurso inventado y único, así como cada una de las piezas que elaboro.</p>
      <p>Creo que las cosas trascienden más allá de lo que son y que una pieza de joyería, puede ser un sentimiento, una decisión, un lugar, una persona, una experiencia, un discurso escrito de otra forma.</p>
      <h4><a className="back" href="/"><HomeIcon /></a></h4>
    </div>

  </div>
)

export const query = graphql`
  query AcercaDeQuery{
    imageSharp(id: { regex: "/mainbg/" }) {
      sizes(maxWidth: 1500) {
        ...GatsbyImageSharpSizes
      }
    }    
  }
`

export default AcercaDe





// WEBPACK FOOTER //
// ./src/pages/acerca-de.js